//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,theia: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const theiaResultsetData = data['theiaResultset']
    formData.isInvalidDoc = theiaResultsetData['is_invalid_doc']?theiaResultsetData['is_invalid_doc']:false
    formData.isOverrideInsuranceCo = theiaResultsetData['is_override_insurance_co']?theiaResultsetData['is_override_insurance_co']:false
    
    if (theiaResultsetData['deposit_account']){
        formData.depositAccount = theiaResultsetData['deposit_account']
    }
    if (theiaResultsetData['insurance_co']){
        formData.insuranceCo = theiaResultsetData['insurance_co']
    }
    if (theiaResultsetData['check_date']){
        formData.checkDate = theiaResultsetData['check_date']
    }
    if (theiaResultsetData['check_amount']){
        formData.checkAmount = parseFloat(theiaResultsetData['check_amount'])
    }
    if (theiaResultsetData['check_no']){
        formData.checkNo = theiaResultsetData['check_no']
    }
    if (theiaResultsetData['fname_insured']){
        formData.fnameInsured = theiaResultsetData['fname_insured']
    }
    if (theiaResultsetData['lname_insured']){
        formData.lnameInsured = theiaResultsetData['lname_insured']
    }
    if (theiaResultsetData['coverpage_date']){
        formData.coverPageDate = theiaResultsetData['coverpage_date']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/theia/editFormData.js